import beginOrEndOfSeaPassage from './beginOrEndOfSeaPassage.svg';
import bnwas from './bnwas.svg';
import safetyAndSecurity from './safetyAndSecurity.svg';

export default {
  beginOrEndOfSeaPassage,
  bnwas,
  safetyAndSecurity,
};
